// ===== Constants =====

import {
    SERIALIZED_INITIAL_EDITOR_VALUE,
} from '../constants/generalConstants';

const hasSlateContent = (value: string): boolean => !(
    value === SERIALIZED_INITIAL_EDITOR_VALUE
    || !value
);

export default hasSlateContent;
